module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm Gold Stainless Steel + Stone Open.e9175a54.png";